// VPS translations

const vps = {
  en: {
    vps: {
      title: "Virtual Private Server",
      subtitle: "Full root access, DDoS protection, and instant setup – from €1.00/month. Choose the VPS type that fits your needs.",
      from: "from",
      perMonth: "/mo",
      trustpilot: "Stars on Google",
      notSure: "Not sure which VPS fits your needs?",
      useProductFinder: "Use Product Finder",
      benefits: "DDoS Protection|PrePaid – No Contract|Full Root Access|Frankfurt Location|1 Gbit Network|Instant Setup",
      configureNow: "Configure Now",
      everythingIncluded: "Everything included",
      otherTypes: "Other VPS Types",
      backToAll: "All VPS",
      prepaid: "PrePaid",
      noContract: "No Contract",
      badge_fastest: "Fastest",
      badge_windows: "Windows",
      spec_cpu: "CPU",
      spec_ram: "RAM",
      spec_storage: "Storage",
      spec_traffic: "Traffic",
      spec_network: "Network",
      spec_os: "Operating System",
      spec_access: "Access",
      spec_model: "Processor",
      // Storage VPS
      storage_title: "Storage VPS",
      storage_tagline: "Massive HDD-RAID storage – perfect for Nextcloud or backup servers.",
      storage_desc: "Our Storage VPS systems offer an affordable price with reliable HDD storage in RAID. Fully virtualized with VMware ESXi – ideal for Nextcloud, backup storage, or archive servers.",
      storage_meta: "Storage VPS with large HDD RAID storage, VMware ESXi and 1 Gbit/s network – ideal for Nextcloud, backups and archives. Prepaid, no contract.",
      storage_hero1: "Your Data.",
      storage_hero2: "Safe & Redundant.",
      storage_feat1: "HDD RAID",
      storage_feat1_desc: "Hardware RAID and node monitoring detect hardware failures early to prevent data loss.",
      storage_feat2: "FairUse Traffic",
      storage_feat2_desc: "Monthly traffic limit equals twice the storage capacity – no surprise overages.",
      storage_feat3: "VMware ESXi",
      storage_feat3_desc: "Enterprise virtualization. Install Windows or any Linux distribution.",
      storage_feat4: "Multiple OS",
      storage_feat4_desc: "Windows, Debian, Ubuntu and more – one-click installation via ISO.",
      storage_feat5: "Fast Delivery",
      storage_feat5_desc: "Server delivered within a few hours after successful payment.",
      storage_feat6: "1 Gbit Network",
      storage_feat6_desc: "High-speed 1 Gbit network uplink included on every plan.",
      // KVM Ryzen VPS
      ryzen_title: "KVM VPS Ryzen",
      ryzen_tagline: "AMD Ryzen 7900/8700G · NVMe SSD · Up to 40 TB Traffic",
      ryzen_desc: "Fast, faster, KVM Ryzen NVMe! Our NVMe servers feature high-clocking AMD Ryzen 7900/8700G processors with at least 3.7 GHz combined with ultra-fast NVMe storage.",
      ryzen_meta: "KVM VPS with AMD Ryzen 7900/8700G (3.7 GHz+), NVMe SSD and up to 40 TB traffic. Full root access, DDoS protection, prepaid with no contract.",
      ryzen_hero1: "Maximum Performance.",
      ryzen_hero2: "AMD Ryzen + NVMe.",
      ryzen_feat1: "AMD Ryzen CPUs",
      ryzen_feat1_desc: "Ryzen 7900/8700G – 3.7 GHz+ clock speed for peak single-thread performance.",
      ryzen_feat2: "NVMe SSD",
      ryzen_feat2_desc: "Ultra-fast NVMe storage minimizes load times and I/O latency.",
      ryzen_feat3: "KVM Virtualization",
      ryzen_feat3_desc: "Full kernel access – upgrade kernel or install custom ISO images.",
      ryzen_feat4: "Up to 40 TB Traffic",
      ryzen_feat4_desc: "Most servers use under 500 GB/month. Upgrade options available if needed.",
      ryzen_feat5: "Aurologic DDoS",
      ryzen_feat5_desc: "Aurologic/PletX DDoS protection on all Ryzen servers.",
      ryzen_feat6: "5-Minute Delivery",
      ryzen_feat6_desc: "Server automatically deployed within 5 minutes after payment.",
      // KVM VPS
      kvm_title: "KVM VPS",
      kvm_tagline: "Intel Xeon · SSD Storage · from €1.00/month",
      kvm_desc: "Enjoy the benefits of fully virtualized KVM servers at a fraction of dedicated server cost. Intel Xeon processors, ECC RAM, and flexible SSD or NVMe storage options.",
      kvm_meta: "KVM VPS with Intel Xeon CPUs, ECC RAM and SSD or NVMe storage. Full root access and DDoS protection – prepaid, no minimum contract.",
      kvm_hero1: "Dedicated Power.",
      kvm_hero2: "VPS Price.",
      kvm_feat1: "Intel Xeon CPUs",
      kvm_feat1_desc: "Intel Xeon / AMD Ryzen processors for reliable, consistent performance.",
      kvm_feat2: "ECC RAM",
      kvm_feat2_desc: "Error-correcting memory maximizes stability and data integrity.",
      kvm_feat3: "KVM Virtualization",
      kvm_feat3_desc: "Full kernel control and custom ISO image support.",
      kvm_feat4: "SSD & NVMe",
      kvm_feat4_desc: "Choose HDD, SSD, or NVMe for the ideal price/performance balance.",
      kvm_feat5: "DDoS Protection",
      kvm_feat5_desc: "DDoS protection included on all servers.",
      kvm_feat6: "5-Minute Delivery",
      kvm_feat6_desc: "Server ready within 5 minutes of payment confirmation.",
      // Windows VPS
      windows_title: "Windows VPS",
      windows_tagline: "Windows Server 2012/2016/2019 included · RDP · from €6.65/month",
      windows_desc: "Manage your Windows VPS like a normal PC via Remote Desktop. All plans include an activated Windows Server 2012, 2016, or 2019 license at no extra cost.",
      windows_meta: "Windows VPS with Windows Server 2012, 2016 or 2019 license included. Manage it via Remote Desktop – DDoS protection, prepaid, no contract.",
      windows_hero1: "Windows Server.",
      windows_hero2: "Ready in 60 minutes.",
      windows_feat1: "RDP Access",
      windows_feat1_desc: "Connect via Remote Desktop from Windows, macOS, or mobile devices.",
      windows_feat2: "Windows License",
      windows_feat2_desc: "Windows Server 2012, 2016, or 2019 fully included – no extra cost.",
      windows_feat3: "VMware ESXi",
      windows_feat3_desc: "Enterprise-grade VMware virtualization for maximum stability.",
      windows_feat4: "NVMe Storage",
      windows_feat4_desc: "250 GB NVMe on all plans for fast I/O performance.",
      windows_feat5: "Unlimited FairUse",
      windows_feat5_desc: "No hard traffic cap. Average server uses under 500 GB/month.",
      windows_feat6: "60-Min Setup",
      windows_feat6_desc: "Server fully set up within 60 minutes after payment.",
    },
  },

  de: {
    vps: {
      title: "Virtueller Privater Server",
      subtitle: "Voller Root-Zugriff, DDoS-Schutz und Sofort-Setup – ab €1,00/Monat. Wähle den VPS-Typ, der zu dir passt.",
      from: "ab",
      perMonth: "/Monat",
      trustpilot: "Stars on Google",
      notSure: "Nicht sicher, welcher VPS zu dir passt?",
      useProductFinder: "Produkt-Finder nutzen",
      benefits: "DDoS-Schutz|Prepaid – kein Vertrag|Voller Root-Zugriff|Standort Frankfurt|1 Gbit Netzwerk|Sofort-Setup",
      configureNow: "Konfigurieren",
      everythingIncluded: "Alles inklusive",
      otherTypes: "Andere VPS-Typen",
      backToAll: "Alle VPS",
      prepaid: "Prepaid",
      noContract: "Kein Vertrag",
      badge_fastest: "Schnellste",
      badge_windows: "Windows",
      spec_cpu: "CPU",
      spec_ram: "RAM",
      spec_storage: "Speicher",
      spec_traffic: "Traffic",
      spec_network: "Netzwerk",
      spec_os: "Betriebssystem",
      spec_access: "Zugriff",
      spec_model: "Prozessor",
      storage_title: "Storage VPS",
      storage_tagline: "Riesiger HDD-RAID-Speicher – perfekt für Nextcloud oder Backup-Server.",
      storage_desc: "Unsere Storage VPS bieten einen günstigen Preis mit zuverlässigem HDD-Speicher im RAID. Vollständig virtualisiert mit VMware ESXi – ideal für Nextcloud, Backup-Speicher oder Archiv-Server.",
      storage_meta: "Storage VPS mit großem HDD-RAID-Speicher, VMware ESXi und 1-Gbit/s-Anbindung – ideal für Nextcloud, Backups und Archive. Prepaid, ohne Vertrag.",
      storage_hero1: "Deine Daten.",
      storage_hero2: "Sicher & Redundant.",
      storage_feat1: "HDD-RAID",
      storage_feat1_desc: "Hardware-RAID und Node-Monitoring erkennen Hardwareausfälle frühzeitig und verhindern Datenverlust.",
      storage_feat2: "FairUse-Traffic",
      storage_feat2_desc: "Monatliches Traffic-Limit entspricht dem doppelten Speicher – keine bösen Überraschungen.",
      storage_feat3: "VMware ESXi",
      storage_feat3_desc: "Enterprise-Virtualisierung. Windows oder beliebige Linux-Distribution installierbar.",
      storage_feat4: "Viele Betriebssysteme",
      storage_feat4_desc: "Windows, Debian, Ubuntu und mehr – Ein-Klick-Installation per ISO.",
      storage_feat5: "Schnelle Bereitstellung",
      storage_feat5_desc: "Server wird wenige Stunden nach erfolgreicher Zahlung bereitgestellt.",
      storage_feat6: "1 Gbit Netzwerk",
      storage_feat6_desc: "Hochgeschwindigkeits-1-Gbit-Netzwerk-Uplink bei jedem Tarif inklusive.",
      ryzen_title: "KVM VPS Ryzen",
      ryzen_tagline: "AMD Ryzen 7900/8700G · NVMe SSD · Bis zu 40 TB Traffic",
      ryzen_desc: "Schnell, schneller, KVM Ryzen NVMe! Unsere NVMe-Server bieten AMD Ryzen 7900/8700G-Prozessoren mit mindestens 3,7 GHz in Kombination mit ultra-schnellem NVMe-Speicher.",
      ryzen_meta: "KVM VPS mit AMD Ryzen 7900/8700G (ab 3,7 GHz), NVMe SSD und bis zu 40 TB Traffic. Voller Root-Zugriff, DDoS-Schutz, Prepaid ohne Vertrag.",
      ryzen_hero1: "Maximale Performance.",
      ryzen_hero2: "AMD Ryzen + NVMe.",
      ryzen_feat1: "AMD Ryzen CPUs",
      ryzen_feat1_desc: "Ryzen 7900/8700G – 3,7 GHz+ Taktfrequenz für maximale Single-Thread-Performance.",
      ryzen_feat2: "NVMe SSD",
      ryzen_feat2_desc: "Ultra-schneller NVMe-Speicher minimiert Ladezeiten und I/O-Latenz.",
      ryzen_feat3: "KVM-Virtualisierung",
      ryzen_feat3_desc: "Voller Kernel-Zugriff – eigenen Kernel aktualisieren oder ISO-Images installieren.",
      ryzen_feat4: "Bis zu 40 TB Traffic",
      ryzen_feat4_desc: "Die meisten Server verbrauchen unter 500 GB/Monat. Upgrade-Optionen verfügbar.",
      ryzen_feat5: "Aurologic DDoS",
      ryzen_feat5_desc: "Aurologic/PletX DDoS-Schutz auf allen Ryzen-Servern.",
      ryzen_feat6: "5-Minuten-Bereitstellung",
      ryzen_feat6_desc: "Server wird automatisch innerhalb von 5 Minuten nach Zahlung bereitgestellt.",
      kvm_title: "KVM VPS",
      kvm_tagline: "Intel Xeon · SSD-Speicher · ab €1,00/Monat",
      kvm_desc: "Genieße die Vorteile vollständig virtualisierter KVM-Server zu einem Bruchteil der Kosten eines Dedicated Servers. Intel Xeon-Prozessoren, ECC-RAM und flexible SSD- oder NVMe-Speicheroptionen.",
      kvm_meta: "KVM VPS mit Intel-Xeon-CPUs, ECC-RAM und SSD- oder NVMe-Speicher. Voller Root-Zugriff und DDoS-Schutz – Prepaid, ohne Mindestlaufzeit.",
      kvm_hero1: "Dedicated-Power.",
      kvm_hero2: "VPS-Preis.",
      kvm_feat1: "Intel Xeon CPUs",
      kvm_feat1_desc: "Intel Xeon / AMD Ryzen Prozessoren für zuverlässige, konsistente Performance.",
      kvm_feat2: "ECC-RAM",
      kvm_feat2_desc: "Fehlerkorrigierender Speicher maximiert Stabilität und Datenintegrität.",
      kvm_feat3: "KVM-Virtualisierung",
      kvm_feat3_desc: "Volle Kernel-Kontrolle und Unterstützung für eigene ISO-Images.",
      kvm_feat4: "SSD & NVMe",
      kvm_feat4_desc: "Wähle zwischen HDD, SSD oder NVMe für das ideale Preis-Leistungs-Verhältnis.",
      kvm_feat5: "DDoS-Schutz",
      kvm_feat5_desc: "DDoS-Schutz auf allen Servern inklusive.",
      kvm_feat6: "5-Minuten-Bereitstellung",
      kvm_feat6_desc: "Server bereit innerhalb von 5 Minuten nach Zahlungsbestätigung.",
      windows_title: "Windows VPS",
      windows_tagline: "Windows Server 2012/2016/2019 inklusive · RDP · ab €6,65/Monat",
      windows_desc: "Verwalte deinen Windows VPS wie einen normalen PC per Remote Desktop. Alle Tarife enthalten eine aktivierte Windows Server 2012-, 2016- oder 2019-Lizenz ohne Aufpreis.",
      windows_meta: "Windows VPS inklusive Lizenz für Windows Server 2012, 2016 oder 2019. Verwaltung per Remote Desktop – DDoS-Schutz, Prepaid, ohne Vertrag.",
      windows_hero1: "Windows Server.",
      windows_hero2: "Fertig in 60 Minuten.",
      windows_feat1: "RDP-Zugriff",
      windows_feat1_desc: "Verbindung per Remote Desktop von Windows, macOS oder mobilen Geräten.",
      windows_feat2: "Windows-Lizenz",
      windows_feat2_desc: "Windows Server 2012, 2016 oder 2019 vollständig inklusive – kein Aufpreis.",
      windows_feat3: "VMware ESXi",
      windows_feat3_desc: "Enterprise-VMware-Virtualisierung für maximale Stabilität.",
      windows_feat4: "NVMe-Speicher",
      windows_feat4_desc: "250 GB NVMe bei allen Tarifen für schnelle I/O-Performance.",
      windows_feat5: "Unbegrenzter FairUse",
      windows_feat5_desc: "Kein hartes Traffic-Limit. Durchschnittlicher Server verbraucht unter 500 GB/Monat.",
      windows_feat6: "60-Minuten-Setup",
      windows_feat6_desc: "Server innerhalb von 60 Minuten nach Zahlung vollständig eingerichtet.",
    },
  },
};

export default vps;
